import React from 'react';
import classNames from 'classnames';
import styles from './article-block.module.scss';
import { ArticleBlockInterface, ArticleContentTypeEnum } from './article-block.interface';
import QuoteBlock from '../quote-block/quote-block.component';
import ArticleVideo from '../article-video/article-video.component';
import Person from '../person/person.component';

const ArticleBlock: React.FunctionComponent<ArticleBlockInterface> = ({
  className,
  title,
  content,
  ...props
}) => {
  return (
    <section
      {...props}
      className={classNames(
        styles.component,
        className,
      )}
    >
      <h2 className={styles.title}>
        {title}
      </h2>

      <div className={styles.content}>
        {content.map(
          (thisItem, thisItemIndex, thisArray) => {
            switch (thisItem.type) {
              case ArticleContentTypeEnum.QUOTE:
                const nextItem = thisArray[thisItemIndex + 1];

                return (
                  <QuoteBlock
                    key={thisItemIndex}
                    title={thisItem.data.title}
                    text={thisItem.data.text}
                    author={thisItem.data.subtext}
                    side={thisItem.data.side}
                    children={typeof thisItem.data.aside === 'object'
                      ? <Person {...thisItem.data.aside} />
                      : thisItem.data.aside
                    }
                    hasAnimation={false}
                    hasBottomBorder={(
                      nextItem
                      && nextItem.type === ArticleContentTypeEnum.QUOTE
                      && !!nextItem.data.title
                      && (thisItemIndex !== thisArray.length - 1)
                    )}
                  />
                );
              case ArticleContentTypeEnum.VIDEO:
                return (
                  <ArticleVideo
                    key={thisItemIndex}
                    videoUrl={thisItem.data.videoUrl}
                    children={thisItem.data.caption}
                  />
                );
            }

            return '';
          },
        )}
      </div>
    </section>
  );
};

export default ArticleBlock;
